// Categorical diagnostics only: never send error text, stacks, URLs or content.
let installed = false;
let remaining = 10;
let endpoint = "";
type DiagnosticKind = "runtime_error" | "unhandled_rejection" | "api_error";
export function reportDiagnostic(kind: DiagnosticKind, requestID = "", status = 0): void {
  if (!endpoint || remaining <= 0) return;
  remaining -= 1;
  const safeID = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(requestID) ? requestID : "";
  try { void fetch(endpoint, {
    method: "POST", credentials: "omit", mode: "cors", referrerPolicy: "no-referrer",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ surface: "front", kind, request_id: safeID, ...(status >= 400 && status <= 599 ? { status } : {}) }),
    signal: AbortSignal.timeout(3000),
  }).catch(() => undefined); } catch { /* Keep diagnostics non-blocking. */ }
}
export function installDiagnostics(url: string): void {
  if (installed || !url || typeof window === "undefined" || ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname)) return;
  try { if (new URL(url).protocol !== "https:") return; } catch { return; }
  installed = true;
  endpoint = url;
  window.addEventListener("error", () => reportDiagnostic("runtime_error"));
  window.addEventListener("unhandledrejection", () => reportDiagnostic("unhandled_rejection"));
}
